<div class="header-container">
    <h4>User Usage (excl. key accounts)</h4>
    <nz-skeleton [nzLoading]="isLoading" [nzParagraph]="{ rows: 0 }" [nzActive]="true">
        @if (insights.length) {
        <div>
            DAU {{ dau }} · WAU {{ wau }} · MAU {{ mau }} · Active Usage Rate {{ activeRate | percent:'1.0-1' }} ({{ mau }} / {{ totalAccounts }})
            <span nz-icon nzType="question-circle" nzTheme="outline"
                nz-tooltip="User usage excludes key accounts. DAU / WAU / MAU = users active in the last 24h / 7d / 30d.
                Active Usage Rate = MAU / total accounts (without key accounts)"></span>
        </div>
        }
    </nz-skeleton>
</div>
@if (!isLoading && !insights.length) {
<nz-empty nzNotFoundContent="No user data"></nz-empty>
} @else {
<nz-table nzTemplateMode [nzLoading]="isLoading" nzSize="small">
    <thead>
        <tr>
            <th rowSpan="2">Email</th>
            <th colSpan="3">Activity</th>
        </tr>
        <tr>
            <th>Last 24h</th>
            <th>Last 7d</th>
            <th>Last 30d</th>
        </tr>
    </thead>
    <tbody>
        @for (user of insights; track $index) {
        <tr>
            <td>
                {{ user.email }}
                @if (isKeyAccount(user.email)) {
                <nz-tag nzColor="gold">Key Account</nz-tag>
                }
                @if (isDecisionMaker(user.email)) {
                <nz-tag nzColor="blue">{{ decisionMakerLabel() }}</nz-tag>
                }
            </td>
            <td>{{ user.count_24h }}</td>
            <td>{{ user.count_7d }}</td>
            <td>{{ user.count_30d }}</td>
        </tr>
        }
    </tbody>
</nz-table>
}

<div class="header-container">
    <h4>Feature Usage per User (incl. key accounts)</h4>
    @if (featureUsage.length) {
    <div class="chart-type-toggle">
        <button nz-button [nzType]="userChartType === 'bar' ? 'primary' : 'default'" (click)="setUserChartType('bar')">Stacked bar</button>
        <button nz-button [nzType]="userChartType === 'line' ? 'primary' : 'default'" (click)="setUserChartType('line')">Line</button>
    </div>
    }
</div>
@if (!isLoading && !featureUsage.length) {
<nz-empty nzNotFoundContent="No feature data"></nz-empty>
} @else if (userFeatureChartOptions && featureUsage.length) {
<div class="user-feature-chart">
    <apx-chart
        [series]="userFeatureChartOptions.series"
        [chart]="userFeatureChartOptions.chart"
        [xaxis]="userFeatureChartOptions.xaxis"
        [plotOptions]="userFeatureChartOptions.plotOptions"
        [dataLabels]="userFeatureChartOptions.dataLabels"
        [stroke]="userFeatureChartOptions.stroke!"
        [tooltip]="userFeatureChartOptions.tooltip!">
    </apx-chart>
</div>
}

<div class="header-container">
    <h4>Feature Usage (incl. key accounts)</h4>
</div>
@if (!isLoading && !featureUsage.length) {
<nz-empty nzNotFoundContent="No feature data"></nz-empty>
} @else {
<div class="feature-usage">
    @if (featureChartOptions && featureUsage.length) {
    <div class="feature-chart">
        <apx-chart
            [series]="featureChartOptions.series"
            [chart]="featureChartOptions.chart"
            [xaxis]="featureChartOptions.xaxis"
            [plotOptions]="featureChartOptions.plotOptions"
            [dataLabels]="featureChartOptions.dataLabels">
        </apx-chart>
    </div>
    }
    <div class="feature-table">
        <nz-table nzTemplateMode [nzLoading]="isLoading" nzSize="small">
            <thead>
                <tr>
                    <th>Feature</th>
                    <th>Total opens</th>
                </tr>
            </thead>
            <tbody>
                @for (feature of featureUsage; track feature.key) {
                <tr>
                    <td>{{ featureLabel(feature.key) }}</td>
                    <td>{{ feature.count }}</td>
                </tr>
                }
            </tbody>
        </nz-table>
    </div>
</div>
}
